import { alkymetricsClient } from '../alkymetricsClient';

export const dashboardInvitationSendCode = async (body) => {
  const response = await alkymetricsClient.post(`/dashboardInvitation/code`, body);
  return response?.data;
};

export const acceptDashboardInvitation = async (body) => {
  const response = await alkymetricsClient.post('/dashboardInvitation/accept', body);
  return response;
};

export const hasDashboardInvite = async (recruitSessionId) => {
  const response = await alkymetricsClient.get(
    `/dashboardInvitation/hasInvite/${recruitSessionId}`
  );
  return response.data;
};

export const guestData = async (recruitSessionId) => {
  const response = await alkymetricsClient.get(
    `/dashboardInvitation/guestData/${recruitSessionId}`
  );
  return response.data;
};
